import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils";
import { Body } from "../../atoms";
export var TestimonialSlide = function(param) {
    var testimonial = param.testimonial, className = param.className;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge(cx("grid grid-cols-1 grid-flow-row auto-rows-auto gap-5", className))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-[auto_minmax(0,1fr)] gap-5 md:gap-7"
    }, /*#__PURE__*/ React.createElement("span", {
        role: "presentation",
        className: "mt-[-0.3em] pointer-events-none text-brand-primary-light text-7xl md:text-9xl"
    }, "“"), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, null, testimonial))));
};

//# sourceMappingURL=TestimonialSlide.js.map